import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtManageOrganizationService} from '@app/services/gt-manage-organization.service';
import {environment} from '@environment';
import {Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {GtProducts} from '../models/enums/gt-products.enum';

@Injectable({
  providedIn: 'root'
})
export class WebRTCPhoneGuard implements CanActivate {
  constructor(
    private authenticationService: GtAuthenticationService,
    private manageOrganizationService: GtManageOrganizationService,
    private router: Router
  ) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    this.manageOrganizationService.resetManaged();
    return this.authenticationService.getSubscriptions().pipe(
      switchMap(() => {
        return this.authenticationService.hasOneOf(GtProducts.WEBRTC_PRODUCT).pipe(
          map(hasWebRTCPhone => {
            if (!hasWebRTCPhone) {
              this.router.navigate([environment.noAccessRedirectRoute]);
              return false;
            }
            return true;
          })
        );
      })
    );
  }
}
